import {
  MaterialReactTable,
  MRT_ShowHideColumnsButton,
  MRT_ToggleFiltersButton,
  MRT_ToggleFullScreenButton,
} from "material-react-table";

import DatagridTooltipProvider from "./datagridTooltipProvider.js";
import { useState } from "react";
import { Fragment } from "react";
import { useEffect } from "react";
import { useMemo, useRef } from "react";
import { connect } from "react-redux";

import FileDownloadIcon from "@mui/icons-material/Download";
import EditIcon from "@mui/icons-material/Edit";
import ClearIcon from "@mui/icons-material/FilterAltOff";
import ClearSortingIcon from "@mui/icons-material/MobiledataOff";
import RefreshIcon from "@mui/icons-material/Refresh";
import { Box, IconButton, Tooltip } from "@mui/material";
import { useMediaQuery } from "@mui/material";
import { alpha } from "@mui/material/styles";
import { useTheme } from "@mui/material/styles";

import {
  mrtGetBodyRowSx,
  mrtGetBottomToolbarSx,
  mrtGetContainerSx,
  mrtGetPaperSx,
  mrtGetTableWrapperSx,
  mrtGetTopToolbarFlexSx,
} from "../../utils/helpers";

import constants from "../../assets/constants";
import { createNewReport, createNewReportData } from "../../data/omniDataModel";
import * as AdminSessionActions from "../../state/redux/adminSession";
import { capitalizeAllWords, getReportOnlyFields } from "../../utils/helpers";
import { createOmniPaginationObject, formatIsoDateString } from "../../utils/helpers";
import TextInputDialog from "../dialogs/textInputDialog";
import OmniGridButton from "../ui/omniGridButton";

const calculateColumns = userID => {
  //default case
  let theReturn = [
    {
      accessorKey: "_id",
      header: "ID",
      size: 150,
      enableColumnFilterModes: false,
    },
    {
      accessorKey: "omniData.rows",
      header: "#",
      size: 60,
      enableColumnFilterModes: false,
      enableColumnFilter: false,

      muiTableHeadCellProps: {
        align: "center",
      },
      muiTableBodyCellProps: {
        align: "center",
      },
      Cell: ({ cell }) => (
        <Box component="span">{`${cell.getValue() == null ? "-" : cell.getValue()}`}</Box>
      ),
    },
    {
      accessorKey: "omniData.name",
      header: "Name",
      enableColumnFilterModes: false,
      enableSorting: false,
      grow: true,
    },
    {
      accessorKey: "omniData.reportType",
      enableColumnFilterModes: false,
      header: "Type",
      minSize: 125,
      enableSorting: false,
      grow: false,

      muiTableHeadCellProps: {
        align: "center",
      },
      muiTableBodyCellProps: {
        align: "center",
      },

      filterFn: "equals",
      filterSelectOptions: [
        { text: "Patients for Org", value: "patientsForOrganization" },
        { text: "invites", value: "invites" },
        { text: "Communications", value: "communications" },
        { text: "Users", value: "users" },
      ],
      filterVariant: "select",

      //custom conditional format and styling
      Cell: ({ cell }) => (
        <Box
          component="span"
          sx={theme => ({
            backgroundColor: theme.palette.info.main,
            borderRadius: "0.25rem",
            color: "#fff",
            maxWidth: "14ch",
            minWidth: "14ch",
            p: "0.25rem",
          })}
        >
          {cell.getValue() === "patientsForOrganization"
            ? "Patients for Org"
            : capitalizeAllWords(cell.getValue())}
        </Box>
      ),
    },
    {
      accessorKey: "omniData.status",
      enableColumnFilterModes: false,
      header: "Status",
      minSize: 125,
      enableSorting: false,
      grow: false,

      muiTableHeadCellProps: {
        align: "center",
      },
      muiTableBodyCellProps: {
        align: "center",
      },

      filterFn: "equals",
      filterSelectOptions: [
        { text: "Requested", value: "requested" },
        { text: "In Progress", value: "inProgress" },
        { text: "Ready", value: "ready" },
        { text: "Error", value: "error" },
      ],
      filterVariant: "select",

      //custom conditional format and styling
      Cell: ({ cell }) => (
        <Box
          component="span"
          sx={theme => ({
            backgroundColor:
              cell.getValue() === "ready"
                ? theme.palette.success.main
                : cell.getValue() === "error"
                  ? theme.palette.error.main
                  : theme.palette.info.main,
            borderRadius: "0.25rem",
            color: "#fff",
            maxWidth: "14ch",
            minWidth: "14ch",
            p: "0.25rem",
          })}
        >
          {cell.getValue() === "inProgress" ? "In Progress" : capitalizeAllWords(cell.getValue())}
        </Box>
      ),
    },
    {
      accessorKey: "omniAudit.createdBy",
      enableColumnFilterModes: false,
      header: "Owner",
      minSize: 125,
      enableSorting: false,
      grow: false,

      muiTableHeadCellProps: {
        align: "center",
      },
      muiTableBodyCellProps: {
        align: "center",
      },

      filterFn: "equals",
      filterSelectOptions: [{ text: "Me", value: userID }],
      filterVariant: "select",

      //custom conditional format and styling
      Cell: ({ cell }) => (
        <Box
          component="span"
          sx={theme => ({
            backgroundColor:
              cell.getValue() === userID ? theme.palette.success.main : theme.palette.info.main,
            borderRadius: "0.25rem",
            color: "#fff",
            maxWidth: "14ch",
            minWidth: "14ch",
            p: "0.25rem",
          })}
        >
          {cell.getValue() === userID ? "You" : "Others"}
        </Box>
      ),
    },
    {
      accessorKey: "omniAudit.createdDate",
      enableColumnFilterModes: false,
      header: "Created",
      size: 125,

      muiTableHeadCellProps: {
        align: "center",
      },
      muiTableBodyCellProps: {
        align: "center",
      },
      enableColumnFilter: false,
      //custom conditional format and styling
      Cell: ({ cell }) => <Box component="span">{`${formatIsoDateString(cell.getValue())}`}</Box>,
    },
  ];

  let reportData = createNewReportData();
  for (var aProp in reportData) {
    if (aProp !== "demo") {
      let theVal = {
        accessorKey: `omniData.reportData.${aProp}`,
        header: capitalizeAllWords(aProp.replace("score", "").replace(/([A-Z]+)/g, " $1")),
        // size: 250,
        muiTableHeadCellProps: {
          align: "center",
        },
        muiTableBodyCellProps: {
          align: "center",
        },
        enableColumnFilterModes: false,
      };
      theReturn.push(theVal);
    }
  }

  return theReturn;
};

const getInitialState = () => {
  let theReturn = {
    density: "compact",
    columnVisibility: {
      _id: false,
      "omniData.givenName": true,
      "omniData.familyName": true,
      "omniData.mobilePhone": false,
      "omniData.email": false,
    },
  };

  let reportData = createNewReportData();
  for (var aProp in reportData) {
    if (aProp !== "demo") {
      theReturn.columnVisibility[`omniData.reportData.${aProp}`] = false;
    }
  }
  theReturn.columnVisibility["omniData.reportData.scorePHQ9"] = true;
  theReturn.columnVisibility["omniData.reportData.scoreIndependentFunction"] = true;

  return theReturn;
};

export const SurveyReports = props => {
  const {
    reportODMs,
    onEditReport = null,
    // onViewReport = null,
    onRequestNewPage = null,
    isLoading = false,
    reportPagination = createOmniPaginationObject,
    userODM,
  } = props;

  const theme = useTheme();
  const mobileLayout = useMediaQuery(theme.breakpoints.down("sm"));
  const tableContainerRef = useRef(null); //we can get access to the underlying TableContainer element and react to its scroll events

  const columns = useMemo(() => calculateColumns(userODM ? userODM._id : null), [userODM]);
  const initialState = useMemo(() => getInitialState(), []);

  const [showReportNameInput, setShowReportNameInput] = useState(null);

  const [rowCount, setRowCount] = useState(0);

  useEffect(() => {
    if (reportPagination != null) {
      setPagination({
        pageIndex: reportPagination.pageIndex - 1,
        pageSize: reportPagination.pageSize,
      });
      setRowCount(reportPagination.totalItems);
    }
  }, [reportPagination]);

  const [sorting, setSorting] = useState([]);

  const [columnFilters, setColumnFilters] = useState([]);

  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 10,
  });

  useEffect(() => {
    let newQuery = {};
    columnFilters.forEach(element => {
      newQuery[element.id] = {
        "#regex": `${element.value}`,
        "#options": "i",
      };
    });

    let newSorting = {};
    sorting.forEach(element => {
      newSorting[element.id] = element.desc ? -1 : 1;
    });

    if (
      reportPagination &&
      (pagination.pageIndex + 1 !== reportPagination.pageIndex ||
        pagination.pageSize !== reportPagination.pageSize ||
        JSON.stringify(pagination.query) !== JSON.stringify(columnFilters))
    ) {
      let newPage = createOmniPaginationObject(reportPagination);
      newPage.pageIndex = pagination.pageIndex + 1;
      newPage.pageSize = pagination.pageSize;
      newPage.query = newQuery;
      newPage.sort = newSorting;

      onRequestNewPage(newPage);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [columnFilters, sorting, pagination.pageIndex, pagination.pageSize]);

  if (reportODMs == null) {
    return <Fragment></Fragment>;
  }

  return (
    <DatagridTooltipProvider>
      <Box sx={mrtGetTableWrapperSx(0, !reportODMs?.length)}>
      <MaterialReactTable
      layoutMode="grid"
      muiTableBodyRowProps={{ sx: mrtGetBodyRowSx() }}
      columns={columns}
      data={reportODMs}
      initialState={initialState}
      defaultColumn={{
        minSize: 20, //allow columns to get smaller than default
        maxSize: 9001, //allow columns to get larger than default
        size: 100, //make columns wider by default
        grow: false,
      }}
      state={{
        columnFilters,
        isLoading,
        pagination,
        sorting,
      }} //pass our managed row selection state to the table to use
      //pagination
      manualPagination={true}
      onColumnFiltersChange={setColumnFilters}
      onPaginationChange={setPagination}
      //header
      enableColumnActions={false}
      enableStickyHeader={true}
      manualSorting
      manualFiltering
      onSortingChange={setSorting}
      enableColumnFilterModes={true}
      filterFns={{
        customFilterFn: (row, id, filterValue) => {
          return row.getValue(id) === filterValue;
        },
      }}
      muiTableHeadCellFilterTextFieldProps={{
        sx: {
          "& .MuiInputBase-input": { padding: "6px" },

          "& .MuiInputBase-root": { paddingRight: "0px" },
          "& .MuiSelect-iconOutlined": { marginRight: "0.75rem" },
          width: "100%",
        },
        variant: "outlined",
      }}
      //row
      enableRowActions={true}
      enableRowSelection={false}
      getRowId={originalRow => originalRow._id}
      rowCount={rowCount}
      positionToolbarAlertBanner="bottom"
      muiTablePaginationProps={{
        rowsPerPageOptions: [5, 10, 20],
      }}
      renderTopToolbarCustomActions={() => <Box sx={{ minHeight: "40px" }} />}
      muiTopToolbarProps={{
        sx: {
          ...mrtGetTopToolbarFlexSx(),
          backgroundColor: theme.palette.commonground.main,
          color: theme.palette.secondary.main,
        },
      }}
      muiBottomToolbarProps={{
        sx: mrtGetBottomToolbarSx(theme),
      }}
      muiTablePaperProps={{
        sx: mrtGetPaperSx(),
      }}
      muiTableContainerProps={{
        ref: tableContainerRef, //get access to the table container element
        sx: mrtGetContainerSx(theme, mobileLayout),
      }}
      muiTableProps={{
        sx: {
          backgroundColor: theme.palette.commonground.main,
          color: theme.palette.commonground.main,
        },
      }}
      muiTableHeadCellProps={{
        sx: {
          backgroundColor: alpha(theme.palette.commonground.contrastText, 0.25),
          color: theme.palette.commonground.contrastText,
          justifyContent: "start",
        },
      }}
      renderRowActions={({ row }) => (
        <Box
          sx={{
            display: "flex",
            flexWrap: "nowrap",
            gap: "2px",
            padding: 0,
          }}
        >
          <OmniGridButton
            sx={{ ...(onEditReport == null && { display: "none" }) }}
            position="relative"
            onClick={() => {
              onEditReport(row.original);
            }}
            icon={<EditIcon fontSize="small" />}
          />

          {row.original.omniData.status === "ready" && (
            <OmniGridButton
              key="Download"
              onClick={() => {
                if (row.original.omniData.url != null) {
                  window.open(`${row.original.omniData.url}`, "_blank", "noreferrer");
                }
              }}
              icon={<FileDownloadIcon fontSize="small" />}
            />
          )}

          {(row.original.omniData.status === "inProgress" ||
            row.original.omniData.status === "requested") && (
            <OmniGridButton
              key="Refresh"
              onClick={() => {
                let newPage = createOmniPaginationObject(reportPagination);
                newPage.invalidateCache = true;

                onRequestNewPage(newPage);
              }}
              icon={<RefreshIcon fontSize="small" />}
            />
          )}
        </Box>
      )}
      renderToolbarInternalActions={({ table }) => (
        <Box>
          {sorting.length > 0 && (
            <Tooltip title="Clear All Sorting" arrow>
              <IconButton
                sx={{ color: theme.palette.secondary.main }}
                onClick={() => {
                  setSorting([]);
                }}
              >
                <ClearSortingIcon />
              </IconButton>
            </Tooltip>
          )}
          {columnFilters.length > 0 && (
            <Tooltip title="Clear All Filters" arrow>
              <IconButton
                sx={{ color: theme.palette.secondary.main }}
                onClick={() => {
                  setColumnFilters([]);
                }}
              >
                <ClearIcon />
              </IconButton>
            </Tooltip>
          )}
          {/* eslint-disable react/jsx-pascal-case*/}
          {/* <MRT_ToggleGlobalFilterButton table={table} /> */}
          <MRT_ToggleFiltersButton table={table} />
          <MRT_ShowHideColumnsButton table={table} />
          <MRT_ToggleFullScreenButton table={table} />
          {/* eslint-enablereact/jsx-pascal-case */}

          {showReportNameInput && (
            <TextInputDialog
              dialogTitle="Report Name"
              dialogMessage={"Please name your report"}
              inputLabel={`${"Report Name"}`}
              defaultValue={showReportNameInput}
              open={showReportNameInput}
              onAccept={theText => {
                /// do it!
                //create the report ..

                let theReport = createNewReport();
                theReport.omniData.name = theText;
                theReport.omniData.reportType = constants.reportTypeEnums.users;

                theReport.omniData["userType"] = "report";

                theReport.omniData["onlyFields"] = getReportOnlyFields(
                  constants.reportTypeEnums.users,
                  true,
                );
                let theQuery = reportPagination.query;

                theReport.omniData["query"] = theQuery;
                delete theReport.omniData.dateBefore;
                delete theReport.omniData.dateAfter;

                props.createReportRequest(theReport);

                setShowReportNameInput(false);
              }}
              onClose={() => {
                setShowReportNameInput(false);
              }}
            />
          )}
        </Box>
      )}
      />
      </Box>
    </DatagridTooltipProvider>
  );
};

const mapStateToProps = state => ({
  userODM: state.userSession.userODM,
});

const mapDispatchToProps = {
  createReportRequest: AdminSessionActions.createReportRequest,
};
export default connect(mapStateToProps, mapDispatchToProps)(SurveyReports);
